import Vue from 'vue'
import Vuex from 'vuex'
import Diary from './diary'
import Food from './food';
import User from './user'
import Message from './message'
import Subscriptions from './subscriptions';
import Ui from './ui';
import Profile from './profile';

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    Diary,
    Food,
    User,
    Message,
    Subscriptions,
    Ui,
    Profile
  }
})
